/**
 * Core types and interfaces for Langton's Ant Gallery
 * Requirements: 2.1-2.11
 */

// Grid Types - форма ячеек сетки
export enum GridType {
  Square = 'square',
  Triangular = 'triangular',
  Hexagonal = 'hexagonal'
}

// Topologies - способ отождествления границ сетки
export enum Topology {
  Torus = 'torus',
  KleinBottle = 'klein',
  ProjectivePlane = 'projective',
  Sphere = 'sphere'
}

// Direction type - направление муравья (зависит от типа сетки)
// 0-3 для квадратной, 0-2 для треугольной, 0-5 для шестиугольной
export type Direction = number;

// Position - позиция на сетке
export interface Position {
  x: number;
  y: number;
}

// Ant - состояние муравья
export interface Ant {
  position: Position;
  direction: Direction;
}

// SimulationConfig - конфигурация симуляции
export interface SimulationConfig {
  id: string;
  name: string;
  gridType: GridType;
  topology: Topology;
  width: number;
  height: number;
  colors: string[];        // Палитра цветов (hex)
  ruleSet: Direction[];    // Повороты для каждого цвета
  speed: number;           // Шагов в секунду
  startPosition: Position;
  avatarUrl: string;
  musicUrl?: string;
  visible: boolean;
  cellGapX?: number;       // Горизонтальный отступ между ячейками сетки (по умолчанию 0)
  cellGapY?: number;       // Вертикальный отступ между ячейками сетки (по умолчанию 0)
}

// SimulationState - текущее состояние симуляции
export interface SimulationState {
  grid: number[][];        // Индексы цветов
  ant: Ant;
  stepCount: number;
}
